import type { DatoxActivityLog } from "./api"

export const ACTIVITY_LIMIT = 250

export function activityDate(value: string) {
  const date = new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}Z`)
  return Number.isNaN(date.getTime()) ? undefined : date
}

export function activityDescription(item: DatoxActivityLog) {
  return item.kind === "message" && typeof item.payload?.content === "string" ? item.payload.content : item.description || ""
}

export function indexActivity(items: DatoxActivityLog[]) {
  return items.map((item) => ({
    item,
    timestamp: activityDate(item.created_at)?.getTime(),
    search: [item.id, item.title, item.event_type, activityDescription(item), item.project_name, item.period_name,
      item.session_title, item.user_name, item.user_email, item.user_id].filter(Boolean).join(" ").toLocaleLowerCase(),
  }))
}

export function filterActivity(index: ReturnType<typeof indexActivity>, filters: { search: string; project: string; days: number; now: number }) {
  const terms = filters.search.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean)
  const since = filters.days ? filters.now - filters.days * 86_400_000 : undefined
  return index.filter((entry) => (!filters.project || entry.item.project_id === filters.project)
    && (since === undefined || (entry.timestamp !== undefined && entry.timestamp >= since && entry.timestamp <= filters.now))
    && terms.every((term) => entry.search.includes(term))).map((entry) => entry.item)
}

export function sortActivity(items: DatoxActivityLog[], oldest: boolean) {
  return [...items].sort((a, b) => {
    const left = activityDate(a.created_at)?.getTime()
    const right = activityDate(b.created_at)?.getTime()
    if (left === undefined) return right === undefined ? a.id.localeCompare(b.id) : 1
    if (right === undefined) return -1
    return (oldest ? left - right : right - left) || `${a.kind}:${a.id}`.localeCompare(`${b.kind}:${b.id}`)
  })
}

export function groupActivity(items: DatoxActivityLog[]) {
  const groups = new Map<string, { key: string; date?: Date; items: DatoxActivityLog[] }>()
  for (const item of items) {
    const date = activityDate(item.created_at)
    const key = date ? `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}` : "unknown"
    const group = groups.get(key) ?? { key, date, items: [] }
    group.items.push(item)
    groups.set(key, group)
  }
  return [...groups.values()]
}
